<template>
  <div>
    <SearchableTable
      :panel-header="'Klienten'"
      :panel-route="'AddClient'"
      :show-search-bar="true"
      :table-data="filteredClients"
      :table-meta-data="tableMetaData"
      :query-string="'setClientSearchQuery'"
      :initial-search-query="clientSearchQuery"
      :row-click="triggerView"
      :event-value="parentEventValue"
      :default-sort="['attributes.last_name', 'asc']"
    >
      <template #header>
        <b-checkbox
          v-model="onlyActive"
          class="only-active"
          size="is-small"
        >
          Nur als aktiv markierte.
        </b-checkbox>
      </template>
    </SearchableTable>
  </div>
</template>

<script>
/**
 * This file shows all currently stored clients and allows adding and viewing
 * clients; editing and deleting happens on the view page.
 */
import { mapGetters } from "vuex";
import SearchableTable from "../helperComponents/SearchableTable.vue";

export default {
	name: "ClientTable",
	components: { SearchableTable },
	data() {
		return {
			onlyActive: true,
			parentEventValue: undefined,
			allColumns: [
				{ "id": 1, "type": "name", "label": "Name", "sortField": "attributes.last_name" },
				{ "id": 3, "type": "ref", "label": "Gruppe", "field": "group_name", "sortField": "attributes.group.attributes.group_name", "refName": "group", "nowrap": true },
				{ "id": 4, "type": "shallowData", "label": "Kontakterzieher", "field": "educator", "sortField": "educator" },
				{ "id": 5, "type": "boolean", "label": "Aktivität", "field": "all_inactive", "true": "Inaktiv", "false": "Aktiv", "sortField": "attributes.all_inactive"}
			]
		};
	},
	computed: {
		...mapGetters({
			clients: "getClientsFilteredWithContactEducators",
			clientSearchQuery: "getClientSearchQuery"
		}),
		filteredClients() {
			if (!this.clients) return this.clients;
			if (!this.onlyActive) return this.clients;
			return this.clients.filter(c => !c.attributes.all_inactive);
		},
		tableMetaData() {
			// With only active clients shown, the column is all "Aktiv".
			if (!this.onlyActive) return this.allColumns;
			return this.allColumns.filter(c => c.field !== "all_inactive");
		}
	},

	methods: {
		triggerView(client) {
			this.$router.push(
				{ name: "ViewClient", params: { id: client.id, data: client } });
		}
	},
};

</script>

<style scoped>
</style>
